import { useDispatch } from "react-redux";
import axios from "axios";
import { getInventoryPurchaseRtn } from "../../../../../redux/inventory";

export const useSaveRtnPurchase = (
  userData,
  togglePurchaseEntry,
  setShowModal
) => {
  const dispatch = useDispatch();

  const saveRtnPurchase = async (
    updatedProductIdInvoiceSheet,
    purchaseInvoiceFormData
  ) => {
    let endPoint = "add-rtn-purchase";

    if (purchaseInvoiceFormData.returnPurchaseId) {
      alert("Edit Not Available");
      return;
    }

    const { supplier, paymentDetails, additionalDetails, createdBy } =
      purchaseInvoiceFormData;

    const postPurchaseData = {
      supplier,
      paymentDetails,
      additionalDetails,
      createdBy,
      purchaseId: purchaseInvoiceFormData.purchaseId,
      invoice: updatedProductIdInvoiceSheet,
    };

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_COLLEGE_ERP_API}${endPoint}`,
        postPurchaseData,
        {
          params: {
            branch: userData.branch,
            purchaseId: purchaseInvoiceFormData.returnPurchaseId,
            userName: userData.userName,
          },
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        }
      );

      if (res.status === 200) {
        alert("Save Successful");
        dispatch(
          getInventoryPurchaseRtn({
            token: userData.token,
            branch: userData.branch,
          })
        );
        togglePurchaseEntry();
      }
    } catch (err) {
      console.error(err);
      if (
        err.response?.data?.err?.name === "TokenExpiredError" ||
        err.response?.data?.message === "Unauthorized"
      ) {
        sessionStorage.clear();
      }
    } finally {
      setShowModal(false);
    }
  };

  return saveRtnPurchase;
};
